import { render } from "./selectGenders.vue?vue&type=template&id=f1d24790&ts=true"
import script from "./selectGenders.vue?vue&type=script&lang=ts"
export * from "./selectGenders.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__